import housingAffordabilityGridOptions from './housing-affordability-grid-options';

/**
 * Class representing the HousingAffordability Grid.
 */
export default class HousingAffordabilityGrid {
    DataPageInstance;
    gridAPI;
    // the data that come from the server
    rowData;

    /**
     * Page Options for the grid.
     * @type {Object}
     */
    options = {
        annual: housingAffordabilityGridOptions(this, 'annual'),
        quarterly: housingAffordabilityGridOptions(this, 'quarterly'),
    };

    /**
     * Create a HousingAffordabilityGrid instance.
     * @param {Object} DataPageInstance - The instance of the Data Page.
     */
    constructor(DataPageInstance) {
        this.DataPageInstance = DataPageInstance;

        this.initializeGrid();
    }

    /**
     * Initialize the data grid.
     */
    initializeGrid() {
        const gridContainer = this.DataPageInstance._table_container;
        const activePeriod = this.getActivePeriod();

        this.gridAPI = createGrid(gridContainer, this.options[activePeriod]);
        //
        this.getRows();
    }

    /**
     * Fetch data from the server based on request parameters.
     */
    getRows() {
        this.eventGridRequestStart();
        // clear previous Grid data
        this.gridAPI.setGridOption('rowData', []);

        //
        let request = this.getRequestParams();
        // console.log(request);

        fetch(
            `${window.location.origin}/wp-json/trerc-data/v1/housing-affordability-table`,
            {
                method: 'post',
                body: JSON.stringify(request),
                headers: {
                    'Content-Type': 'application/json; charset=utf-8',
                },
            },
        )
            .then((httpResponse) => httpResponse.json())
            .then((response) => {
                let rez = JSON.parse(response);
                this.rowData = rez.rowData;
                // console.log(rez);

                //
                this.gridAPI.setGridOption(
                    'columnDefs',
                    this.options[this.getActivePeriod()].columnDefs,
                );

                // Call the success callback with the parsed response data
                this.gridAPI.setGridOption('rowData', this.rowData);

                this.eventGridRequestEnd('success', rez);
            })
            .catch((error) => {
                // console.error(error);
                this.rowData = {};

                this.eventGridRequestEnd('error', {});
            });
    }

    /**
     * Refresh the data grid.
     */
    refresh() {
        this.getRows();
    }

    /**
     * return the raw data that come from the server
     * @return {*}
     */
    getRowData() {
        return this.rowData;
    }

    /**
     * Get the active period (annual or monthly).
     * @returns {string} - The active period.
     */
    getActivePeriod() {
        return this.DataPageInstance.getActivePeriod();
    }

    /**
     * Get the request parameters.
     * @returns {Object} - The request parameters.
     */
    getRequestParams() {
        return this.DataPageInstance.getRequestParams();
    }

    /**
     * Dispatch a custom event to signal the start of a grid request.
     */
    eventGridRequestStart() {
        const event = new CustomEvent('gridRequest.Start');
        document.dispatchEvent(event);
    }

    /**
     * Dispatch a custom event to signal the end of a grid request.
     * @param {string} type - The type of the grid request (success or error).
     * @param {Object} data - Data associated with the request.
     */
    eventGridRequestEnd(type, data = {}) {
        const event = new CustomEvent('gridRequest.End', {
            bubbles: true,
            detail: {
                type: type,
                data: data,
            },
        });
        document.dispatchEvent(event);
    }
}
